import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/country/[[...slug]]/CountryPageClient.tsx")